module.exports = __webpack_public_path__ + "static/img/bg_fr.7498404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/24-hour-2026-sale/bg_fr.png
// module id = AaoA
// module chunks = 2